// extracted by mini-css-extract-plugin
export var parcelRow = "_ub-0";